import { render } from "./HeaderNew.vue?vue&type=template&id=6f3512a0&scoped=true&lang=pug"
import script from "./HeaderNew.vue?vue&type=script&lang=js"
export * from "./HeaderNew.vue?vue&type=script&lang=js"

import "./HeaderNew.vue?vue&type=style&index=0&id=6f3512a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3512a0"]])

export default __exports__